"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _pclnDesignSystem = require("pcln-design-system");

var _Card = _interopRequireDefault(require("../../../structure/Card"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Container = _styledComponents["default"].div.withConfig({
  componentId: "sc-1ak9kcn-0"
})(["position:relative;display:flex;max-width:300px;width:100%;height:225px;"]);

var StyledBackground = (0, _styledComponents["default"])(_pclnDesignSystem.BackgroundImage).withConfig({
  componentId: "sc-1ak9kcn-1"
})(["display:flex;width:100%;"]);
var HoverCard = (0, _styledComponents["default"])(_Card["default"]).withConfig({
  componentId: "sc-1ak9kcn-2"
})(["position:absolute;display:flex;flex-direction:column;justify-content:center;align-items:center;width:auto;height:100px;background-color:", ";padding:", "px ", "px;left:20px;right:20px;bottom:0;"], (0, _pclnDesignSystem.getPaletteColor)('background.lightest'), (0, _themeGet.themeGet)('space.3'), (0, _themeGet.themeGet)('space.4'));

var Title = _styledComponents["default"].div.withConfig({
  componentId: "sc-1ak9kcn-3"
})(["display:flex;justify-content:center;text-align:center;font-size:", ";font-weight:", ";"], (0, _themeGet.themeGet)('fontSizes.2'), (0, _themeGet.themeGet)('fontWeights.bold'));

var SubTitle = _styledComponents["default"].div.withConfig({
  componentId: "sc-1ak9kcn-4"
})(["display:flex;justify-content:center;color:", ";font-size:", "px;margin-top:", "px;"], (0, _pclnDesignSystem.getPaletteColor)('text.light'), (0, _themeGet.themeGet)('fontSizes.0'), (0, _themeGet.themeGet)('space.1'));

var BenefitCard = (0, _react.memo)(function (_ref) {
  var className = _ref.className,
      backgroundUrl = _ref.backgroundUrl,
      title = _ref.title,
      subTitle = _ref.subTitle;
  return _react["default"].createElement(Container, {
    className: className
  }, _react["default"].createElement(StyledBackground, {
    image: backgroundUrl,
    height: "200px"
  }), _react["default"].createElement(HoverCard, {
    boxShadowSize: "xl"
  }, _react["default"].createElement(Title, null, title), _react["default"].createElement(SubTitle, null, subTitle)));
});
BenefitCard.displayName = 'BenefitCard';
BenefitCard.propTypes = {
  className: _propTypes["default"].string,
  backgroundUrl: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].node.isRequired,
  subTitle: _propTypes["default"].node
};
BenefitCard.defaultProps = {
  className: ''
};
var _default = BenefitCard;
exports["default"] = _default;